import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "../shared/tokens.css";
import "../shared/styles.css";
import "../shared/declic.css";
import { initAuth } from "./auth.js";
import { lang, loadDicts } from "../shared/i18n.js";
import { App } from "./App.js";

document.documentElement.lang = lang;
void initAuth();
const render = () =>
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
// Les textes anglais sont un morceau à part : l'app attend de les avoir (en même temps que la connexion).
if (lang === "en") void loadDicts().then(render, render);
else render();
